import React, { useEffect } from 'react';

const Roadmap = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const milestones = [
        {
            year: '2024',
            stage: 'Ideation & Foundation',
            status: 'completed',
            items: [
                'Project Concept & Market Research',
                'Architecture Design & Tech Stack Selection',
                'Core Scanning Engine Prototype',
                'Initial Security Database Setup'
            ]
        },
        {
            year: '2025',
            stage: 'Launch & Expansion',
            status: 'active',
            items: [
                'MVP Launch with SSL/TLS Monitoring',
                'Vulnerability Assessment Engine',
                'Real-time Traffic Analysis Dashboard',
                'DoS and DDoS Protection Testing Suite'
            ]
        },
        {
            year: '2026',
            stage: 'AI & Intelligence',
            status: 'upcoming',
            items: [
                'AI-Powered Predictive Threat Detection',
                'Automated Vulnerability Remediation',
                'Mobile Application Security Testing',
                'Global Threat Intelligence Integration'
            ]
        },
        {
            year: '2027',
            stage: 'Enterprise Ecosystem',
            status: 'upcoming',
            items: [
                'Multi-Cloud Security Orchestration',
                'Advanced API Security Auditing',
                'Compliance Readiness Automation',
                'Secure360 Community Threat Exchange'
            ]
        }
    ];

    return (
        <div className="roadmap-page py-5 bg-white">
            <div className="container py-5">
                <div className="text-center mb-5">
                    <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill fw-bold mb-3">Our Journey</span>
                    <h1 className="display-4 fw-bold">Secure360 Strategic Roadmap</h1>
                    <p className="text-muted fs-5 mx-auto max-w-[700px]">
                        From a bold idea to an enterprise-grade security ecosystem. Follow our progress as we build the future of digital protection.
                    </p>
                </div>

                {/* Horizontal Timeline Container */}
                <div className="position-relative mt-5 pt-4 overflow-hidden">
                    {/* Main horizontal line */}
                    <div className="position-absolute d-none d-lg-block bg-primary bg-opacity-10 h-[4px] w-[100%] z-[0]" style={{ top: '50px', left: '0' }}></div>

                    <div className="row flex-nowrap overflow-auto pb-5 g-0 timeline-container" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                        {milestones.map((milestone, idx) => (
                            <div className="col-lg-3 col-md-6 col-10 flex-shrink-0" key={idx}>
                                <div className="px-3 position-relative text-center">

                                    {/* Timeline Dot */}
                                    <div className={`mx-auto rounded-circle d-flex align-items-center justify-content-center mb-4 position-relative z-1 shadow-sm ${milestone.status === 'completed' ? 'bg-success text-white' : milestone.status === 'active' ? 'bg-primary text-white scale-125' : 'bg-white border border-2 border-light text-muted'}`}
                                        style={{ transition: 'all 0.3s' }}>
                                        {milestone.status === 'completed' ? <i className="las la-check fs-4"></i> : <span className="fw-bold">{milestone.year}</span>}
                                    </div>

                                    {/* year label for completed/upcoming */}
                                    {milestone.status !== 'active' && <div className="small fw-bold text-muted mb-2">{milestone.year}</div>}
                                    {milestone.status === 'active' && <div className="small fw-bold text-primary mb-2">CURRENT STAGE</div>}

                                    <h5 className="fw-bold mb-3">{milestone.stage}</h5>

                                    <div className="card border-0 shadow-sm rounded-4 p-4 h-100 text-start bg-light">
                                        <ul className="list-unstyled mb-0 small">
                                            {milestone.items.map((item, i) => (
                                                <li key={i} className="mb-2 d-flex align-items-start">
                                                    <i className={`las la-circle me-2 mt-1 text-[8px] ${milestone.status === 'completed' ? 'text-success' : milestone.status === 'active' ? 'text-primary' : 'text-muted opacity-50'}`}></i>
                                                    <span className={milestone.status === 'upcoming' ? 'text-muted' : ''}>{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="text-center mt-5">
                    <p className="text-muted italic small">
                        * Roadmap items and timelines are subject to change based on community feedback and emerging security challenges.
                    </p>
                </div>
            </div>

            <style>{`
        .timeline-container::-webkit-scrollbar { display: none; }
        .scale-125 { transform: scale(1.15); box-shadow: 0 0 20px rgba(13, 110, 253, 0.4) !important; }
      `}</style>
        </div>
    );
};

export default Roadmap;
